var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:_vm.name,style:({fontSize: _vm.size+'px', color:_vm.colorFont}),attrs:{"title":(_vm.title == null ? '' : _vm.title)}})}
var staticRenderFns = []
export { render, staticRenderFns }